import React from 'react'
import styled from 'styled-components'

import colors from 'styles/colors'
import text from 'styles/text'
import media from 'styles/media'

type Props = { 
  value: string,
  setValue: Function
  placeholder: string
  type: string,
  error?: string
  success?: string
}

const Input: React.FC<Props> = ({ value, setValue, placeholder, type, error, success }) => {

  const handleChange = (e: any) => {
    setValue(e.target.value)
  }

  return (
    <Wrapper error={!!error} success={!!success}>
      <Field
        onChange={handleChange}
        value={value}
        placeholder={placeholder}
        type={type}
      />
      {(!!error || !!success) && <Hint>{error || success}</Hint>}
    </Wrapper>
  )
}

export default Input

const Field = styled.input`
  ${text.desktop.bodyS}
  box-sizing: border-box;
  outline: none;
  width: 100%;
  border-radius: 1px;
  cursor: pointer;
  border-style: solid;
  border-color: ${colors.red};

  &::placeholder {
    color: ${colors.black25};
  }

  height: 3.89vw;
  padding-top: 1.11vw;
  padding-bottom: 1.11vw;
  padding-left: 1.67vw;
  padding-right: 1.67vw;

  ${media.tablet} {
    ${text.tablet.bodyS} 
    height: 5.47vw;
    padding-top: 1.56vw;
    padding-bottom: 1.56vw;
    padding-left: 2.34vw;
    padding-right: 2.34vw;
  }

  ${media.mobile} {
    ${text.mobile.bodyS}
    width: 92vw;
    height: 14.933vw;
    padding: 4.267vw 40.533vw 4.267vw 6.4vw;
  }
`

const Hint = styled.p`
  ${text.desktop.bodyS}
  margin-top: 0.56vw;

  ${media.tablet} {
    ${text.tablet.bodyS}
    margin-top: 0.78vw;
  }

  ${media.mobile} {
    ${text.mobile.bodyS}
    margin-top: 2.66vw;
  }
`

const Wrapper = styled.div<{error: boolean, success: boolean}>`
  position: relative;
  z-index: 2;
  height: auto;

  width: 20.9vw;
  margin-bottom: 1.39vw;

  ${media.tablet} {
    margin-bottom: 1.95vw;
    width: 29.395vw;
  }

  ${media.mobile} {
    width: 92vw;
    margin-bottom: 5.333vw;
  }

  &:hover {
    ${Field} {
      background: ${colors.black50};
    }
  }

  ${Field} {
    background: ${props => {
      if (props.error) {
        return 'transparent'
      } else if (props.success) {
        return colors.pureWhite
      } else {
        return colors.black75
      }
    }};
    border-width: ${props => props.error ? "1px" : '0px'};
    color: ${props => {
      if (props.error) {
        return colors.red
      } else if (props.success) {
        return colors.pureBlack
      } else {
        return colors.pureWhite
      }
    }};
  }

  ${Hint} {
    color: ${props => props.error ? colors.red : colors.black25};
  }
`
